<template>
  <div class="footer-bar">
    <template v-if="isScenePlaying || isSceneFinished">
      <div class="footer-bar-wrap" v-show="!isShowAnswerCard">
        <p class="tip">
          <template v-if="isExam">
            点击“Enter”键进入下一题，点击“检查”查看答题卡快速跳转至某题或交卷
            <template v-if="isTHXZ">
              , <span class="danger">点击右上角音频按钮开始答题</span>
            </template>
          </template>
          <template v-else-if="isZSD">点击“Enter”键查看下一个知识点。</template>
          <template v-else>点击“Enter”键继续。</template>
        </p>
        <div class="icons">
          <i class="iconfont icon-arrow-left"
             :class="{ disabled: isFirst }"
             v-if="isExam"
             @click="$emit('prev')"></i>
          <span class="button"  v-if="isExam" @click="$emit('detail')">检查</span>
          <van-speaker
            class="circle primary"
            v-if="isShowSpeaker"
            ref="speaker"
            :src="currentExercise.audio"
            @speak="speak" />
          <i
            class="iconfont icon-eraser"
            @click="clear"
            v-if="isShowEraser"></i>
          <i class="iconfont icon-arrow-right"
             :class="{ disabled: (isLast && this.isExam) || (!this.isExam && !isAnswered) }"
             @click="$emit('next')"></i>
        </div>
      </div>
      <div class="footer-bar-wrap" v-show="isShowAnswerCard && isExam && !isSceneFinished ">
        <p class="tip">
          点击题目编号，可以跳转至对应的题目答题或修改答案，点击【交卷】可提交并计算成绩。
        </p>
        <div class="button-wrap">
          <el-button type="primary" @click="submitExam">交卷</el-button>
        </div>
      </div>
      <div class="footer-bar-wrap"
        v-show="isShowAnswerCard && isExam && isSceneFinished && isShowBottomControl">
        <div class="button-wrap exam-finished">
          <slot name="foot"></slot>
          <el-button
            v-if="isShowReplay"
            :disabled="isDisabledReplay"
            type="primary"
            @click="replay">错题再练</el-button>
          <el-button type="primary" @click="finished">{{finishedText}}</el-button>
        </div>
      </div>
    </template>
    <template v-else-if="isSceneExamList || isSceneComparison">
      <div class="footer-bar-wrap" v-show="!isShowAnswerCard">
        <p class="tip" v-show="isShowTip">
          本次考试共答错 {{wrongNumber}} 题，错题将自动进入"错题本"，可随时复习。
        </p>
        <div class="button-wrap">
          <el-button type="primary" @click="$emit('back')">返回</el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import utils from '@/services/utils';
import Speaker from 'vanthink-components/components/common/Speaker.vue';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  comparison: 5,
});

export default {
  components: {
    VanSpeaker: Speaker,
  },
  props: {
    currentExercise: {
      type: Object,
      default: () => ({}),
    },
    isShowBottomControl: {
      type: Boolean,
      default: false,
    },
    isDisabledReplay: {
      type: Boolean,
      default: false,
    },
    isShowReplay: {
      type: Boolean,
      default: true,
    },
    finishedText: {
      type: String,
      default: '下一步',
    },
    isShowSpeaker: {
      type: Boolean,
      default: false,
    },
    isShowEraser: {
      type: Boolean,
      default: false,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Number,
      default: 0,
    },
    results: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    scene: {
      type: Number,
      require: true,
    },
    isShowAnswerCard: {
      type: Boolean,
      default: false,
    },
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    currentExercise: {
      handler() {
        if (this.isShowSpeaker) {
          this.$nextTick(() => {
            if (this.$refs.speaker) {
              this.$refs.speaker.initPlay();
            }
          });
        }
      },
      immediate: true,
    },
    scene() {
      if (this.scene === 2) {
        this.$nextTick(() => {
          if (this.$refs.speaker) {
            this.$refs.speaker.initPlay();
          }
        });
      }
    },
  },
  computed: {
    isZSD() {
      return this.currentExercise.code === 'ZSD';
    },
    isDX() {
      return this.currentExercise.code === 'DX';
    },
    isTHXZ() {
      return this.currentExercise.code === 'THXZ';
    },
    isFirst() {
      return this.current <= 0;
    },
    isLast() {
      return this.current >= this.total - 1;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isSceneFinished() {
      return this.scene === SCENE.finished;
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isSceneComparison() {
      return this.scene === SCENE.comparison;
    },
    wrongNumber() {
      return this.results.filter(item => !item.isRight).length;
    },
    isAnswered() {
      if (this.isDX) {
        return this.currentExercise.isComplete;
      }
      return true;
    },
  },
  methods: {
    submitExam() {
      utils.confirm('确定要交卷吗，要不要再检查一下？', '提示')
        .then(() => {
          this.$emit('submit');
        });
    },
    clear() {
      this.$emit('clear');
    },
    replay() {
      this.$emit('replay');
    },
    finished() {
      this.$emit('finished');
    },
    speak() {
      this.$emit('speak');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .footer-bar {
    .footer-bar-wrap {
      position: relative;
      display: flex;
      height: 55px;
      .tip {
        flex: 1;
        text-align: left;
        margin: 0;
        color: $grey-color;
        height: 55px;
        line-height: 55px;
      }
      .danger {
        color: $danger;
      }
      .button-wrap {
        position: absolute;
        right: 0;
        top: 7.5px;
      }
      .exam-finished {
        .el-button {
          margin-right: 10px;
        }
      }
      .icons {
        position: absolute;
        right: 0;
        cursor: pointer;
        .button {
          box-sizing: border-box;
          display: inline-block;
          margin-left: 30px;
          width: 45px;
          height: 45px;
          color: #fff;
          font-size: 18px;
          line-height: 45px;
          text-align: center;
          vertical-align: middle;
          background: $primary;
          border-radius: 50%;
          &:hover {
            opacity: .8;
          }
        }
        i {
          font-size: 48px;
          color: $primary;
          margin-left: 30px;
          vertical-align: middle;
          &.disabled {
            color: rgba($grey-color, .2);
            cursor: not-allowed;
            &:active {
              color: rgba($grey-color, .3);
            }
          }
          &:active {
            color: $primary-light;
          }
        }
        /deep/ .speaker {
          width: 43px;
          height: 43px;
          svg {
            width: 27px;
            height: 30px;
            line-height: 30px;
          }
        }
        .icon-eraser {
          border-radius: 50%;
          color: #fff;
          font-size: 42px;
          line-height: 42px;
          background-color: $primary;
        }
      }
    }
  }
</style>
